// @flow
import api from '../api';
import { ticketFormChange } from './ticketForm';

export const FILE_REQUEST = 'FILE_REQUEST';
export const FILE_SUCCESS = 'FILE_SUCCESS';
export const FILE_DELETE = 'FILE_DELETE';
export const FILE_FAILURE = 'FILE_FAILURE';

const fileRequest = () => ({
  type: FILE_REQUEST,
});

const fileSuccess = payload => ({
  type: FILE_SUCCESS,
  payload,
});

export const fileDeleteSuccess = (id: number) => ({
  type: FILE_DELETE,
  payload: id,
});

const fileFailure = payload => ({
  type: FILE_FAILURE,
  payload,
});

export const filePost = (file: string, handleProgress: Function, cb: Function) =>
  async (dispatch: Function, getState: Function) => {
    const data = new FormData();
    data.append('files[]', file);
    dispatch(fileRequest());
    try {
      const res = await api('attachments/files', 'post', { data, onUploadProgress: handleProgress });
      const fileId = parseInt(Object.keys(res.data.files)[0], 10);
      const files = getState().assistance.ticketForm.ticket.filesAccepted;
      dispatch(fileSuccess(res.data.files));
      dispatch(ticketFormChange({ filesAccepted: [...files, fileId] }));
      if (typeof cb === 'function') cb();
    } catch (error) {
      dispatch(fileFailure({ err: 'Отправка файла не удалась' }));
    }
  };

export const fileDelete = (id: number, cb?: (void) => void) => async (dispatch: Function) => {
  try {
    await api('attachments/files', 'delete', { data: { id } });
    dispatch(fileDeleteSuccess(id));
  } catch (error) {
    if (typeof cb === 'function') cb();
    dispatch(fileFailure({ err: 'Не удалось удалить файл' }));
  }
};
